import * as React from 'react'
import { DynamicCx, Menu } from 'common/types'
import { styling } from 'common/utils'
import hostConfig from 'common/config'
import { isWindowService, getSubVerticalPath, usedReactHome } from 'common/constants'
import { VerticalContext } from 'common/context'
import Flag from './Flag'
import * as s from './lnb.scss'
import Link from 'common/components/Link'

interface OwnProps {
  subMenus: Menu[]
  cx?: DynamicCx
}

type Props = OwnProps

const SubLinks: React.SFC<Props> = ({ subMenus, cx }) => (
  <VerticalContext.Consumer>
    {({ vertical, subVertical }) => (
      <ul className={cx('lnb_sub')}>
        {subMenus.map((menu, index) => (
          <li key={menu.title} className={cx(menu.className)}>
            {usedReactHome(menu.subVertical) ? (
              <Link
                to={`${menu.to}/home`}
                className={cx({ active: menu.to === getSubVerticalPath(subVertical) }, menu.nclick)}>
                <span className={cx('txt')}>{menu.title}</span>
                {menu.flag && <Flag flag={menu.flag} />}
              </Link>
            ) : (
              <a
                href={
                  isWindowService(menu.to)
                    ? `${hostConfig.windowUri.pc}${menu.to}/home`
                    : `${hostConfig.verticalUri.pc}${menu.to}`
                }
                className={cx({ active: menu.to === getSubVerticalPath(subVertical) }, menu.nclick)}>
                <span className={cx('txt')}>{menu.title}</span>
                {menu.flag && <Flag flag={menu.flag} />}
              </a>
            )}
          </li>
        ))}
      </ul>
    )}
  </VerticalContext.Consumer>
)

export default styling(s)(SubLinks)
